export enum EChoiceDisplayValues {
    NONE = "",
    FIRST = "0",
    SECOND = "1",
    THIRD = "2",
}
